import { request } from "@/api/client";

export type InvoiceLineInput = {
  description: string
  quantity: number
  unit_price: number
}

export type Invoice = {
  id: string
  invoice_number: string
  customer_name: string
  customer_email?: string | null
  issued_date: string
  due_date?: string | null
  currency: string
  status: string
  notes?: string | null
  subtotal: number
  total?: number
  lines: Array<{ description: string; quantity: number; unit_price: number }>
}

type InvoicePayload = {
  customer_name: string
  customer_email?: string
  issued_date: string
  due_date?: string
  currency?: string
  notes?: string
  lines: InvoiceLineInput[]
  status?: string
}

export async function listInvoices(): Promise<Invoice[]> {
  const payload = await request<{ invoices: Invoice[] }>("/invoices")
  return payload?.invoices ?? []
}

export function createInvoice(payload: InvoicePayload): Promise<Invoice> {
  return request("/invoices", { method: "POST", body: payload })
}

export function updateInvoice(invoiceId: string, payload: InvoicePayload): Promise<Invoice> {
  return request(`/invoices/${encodeURIComponent(invoiceId)}`, { method: "PUT", body: payload })
}

export async function renderInvoiceHtml(id: string): Promise<string> {
  return request(`/invoices/${encodeURIComponent(id)}/html`)
}

export function updateInvoiceStatus(id: string, status: string): Promise<Invoice> {
  return request(`/invoices/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: { status },
  })
}
